let focussedElement: HTMLElement
export function scrollTopListener(node: HTMLElement) {
    focussedElement = node
}

window.addEventListener("toptap", () =>
    focussedElement.scrollTo({
        top: 0,
        behavior: "smooth",
    })
)
